module.exports = __webpack_public_path__ + "static/media/pack.19a72fcb.png";